import { NgIf, AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';

import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { selectRepeatOrder } from 'src/app/store/selectors';

interface ViewModel {
  bulkCount: number;
  generalCargoCount: number;
}

@Component({
  selector: 'app-repeat-order-teaser',
  templateUrl: 'repeat-order-teaser.component.html',
  styleUrls: ['repeat-order-teaser.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, MatButton, RouterLink, MatIcon, AsyncPipe, AgrI18nSharedModule],
})
export class RepeatOrderTeaserComponent {
  readonly vm$: Observable<ViewModel>;

  constructor(private readonly store: Store) {
    this.vm$ = combineLatest([this.store.select(selectRepeatOrder)]).pipe(
      map(([{ bulk, generalCargo }]) => ({
        bulkCount: bulk.length,
        generalCargoCount: generalCargo.length,
      })),
    );
  }
}
